import React, { Suspense } from "react";
import { PopupDetailProfile } from "~/modules/catalogue/components/popup-detail-profile";
import { useGlobalStyles } from "~/styles/context/global-styles-wrapper";
import { Await, useLoaderData } from "@remix-run/react";

export { partnerLoader as loader } from "~/loaders/partner.loader";

export default function Index() {
  const { theme } = useGlobalStyles();
  const { partner } = useLoaderData();
  const storeInfoShowVideo = true;
  const storeInfoShowSocialButtons =
    theme.template.STORE_INFO.PROPS.SHOW_SOCIAL_BUTTONS;
  return (
    <Suspense
      fallback={
        <PopupDetailProfile
          showSocialButtons={storeInfoShowSocialButtons}
          showVideo={storeInfoShowVideo}
        />
      }
    >
      <Await
        resolve={partner}
        errorElement={<p>Error loading package location!</p>}
      >
        {(p) => (
          <PopupDetailProfile
            showSocialButtons={storeInfoShowSocialButtons}
            partner={p}
            showVideo={storeInfoShowVideo}
          />
        )}
      </Await>
    </Suspense>
  );
}
